import * as React from "react";
import { withRouter } from 'react-router-dom';
import { LandingLayout } from './LandingLayout';

export const LandingLayoutWithRouter = withRouter(props => <LandingLayout {...props} />)


// WEBPACK FOOTER //
// ./src/components/template/layouts/LandingLayoutWithRouter.tsx